// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const LazyImage = require('client-v2/common/components/lazy-image')
const ArticleModelRecord = require('client-v2/common/models/article/record')

const bem = BemEntity('ShareModalArticleContent')

function ShareModalArticleContent(props) {
  const { article } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(LazyImage, {
        className: bem.element('article-image'),
        sources: [article.md5image, article.image]
      }),
      tag('div', {
        className: bem.element('details')
      },
        tag('div', {
          className: bem.element('hostname')
        },
          article.hostname
        ),
        tag('div', {
          className: bem.element('heading')
        },
          article.title
        )
      )
    )
  )
}

ShareModalArticleContent.propTypes = {
  className: PropTypes.string,
  article: PropTypes.shape(ArticleModelRecord.propTypes)
}

module.exports = ShareModalArticleContent
